import { render } from "./Number.vue?vue&type=template&id=4a8415eb&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import "./Number.vue?vue&type=style&index=0&id=4a8415eb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a8415eb"

export default script